export default __webpack_public_path__ + "static/media/logo-horiz.625e2f15.svg";